// extracted by mini-css-extract-plugin
export default {"link":"_4eb107c7"};